import React from "react";
import ModalDialog from "./modal-dialog";
import ThreeDotsLoadingSpinner from "./three-dots-loading-spinner";

interface SubmittedMessageResultModalDialogProps {
	visible: boolean;
	loading: boolean;
	mobileIcon: React.ReactNode;
	title: string;
	text: string;
	buttonText: string;
	closeButtonAriaLabel: string;
	onClickCloseButton: () => void;
	onClickMainButton: () => void;
}

function SubmittedMessageResultModalDialog({
	visible,
	loading,
	mobileIcon,
	title,
	text,
	buttonText,
	closeButtonAriaLabel,
	onClickCloseButton,
	onClickMainButton,
}: SubmittedMessageResultModalDialogProps) {
	return (
		<ModalDialog.Wrapper visible={visible}>
			{loading && <ThreeDotsLoadingSpinner />}
			{!loading && (
				<ModalDialog.Panel
					mobileIcon={mobileIcon}
					title={title}
					text={text}
					buttonText={buttonText}
					closeButtonAriaLabel={closeButtonAriaLabel}
					onClickCloseButton={onClickCloseButton}
					onClickMainButton={onClickMainButton}
				/>
			)}
		</ModalDialog.Wrapper>
	);
}

export default SubmittedMessageResultModalDialog;
